<template>
  <div>
    <v-row>
      <div id="hous3" class="col-sm-12">
        <div id="home3">
          <v-row>
            <div class="col-sm-11"></div>
            <div class="col-sm-1">
              <router-link to="/User">
                <v-icon color="blue">mdi-account-circle</v-icon>
              </router-link>
            </div>
          </v-row>
          <h2>Ca Par Mois</h2>
          <Chart/>
        </div>      
      </div>
    </v-row>
  </div>
</template>
<style>
#home3{
  background-color:white !important;
  text-align:center;
}
#hous3{
  text-align:center;
}
</style>
<script>
import Vue from 'vue'

import Chart from "../components/Chart.vue"
import Vuetify from 'vuetify/lib'
Vue.use(Vuetify)

export default {
  name: "Home",
  components: {
    Chart
  },
  data() {
    return {
      loading: false,
      selection: 1,
      chartData: {
        Books: 24,
        Magazine: 30,
        Newspapers: 10
      }
    };
  },
      methods: {
      reserve () {
        this.loading = true
        setTimeout(() => (this.loading = false), 2000)
      },
    },
  
};
</script>


